/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DIALOG_SIZE_SM_MD, DialogContentProps, DialogProps, ICON_ADD_CIRCLE, ICON_EDIT } from '@squiz/sds';
import { useDialogStore } from 'dxpConsoleCore-mf/State';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AI_STRINGS } from '../../Constants/Strings.constants';
import { AiContextItemDialog } from './AiContextItemDialog';
import { UseContextItemDialogOpenProps, UseContextItemDialogResult } from './useContextItemDialog.types';

export const useContextItemDialog = (): UseContextItemDialogResult => {
  const { updateActiveDialog } = useDialogStore();
  const { t } = useTranslation();
  const labels = useMemo(
    () => ({
      createContextItem: t(AI_STRINGS.createContextItem),
      editContextItem: t(AI_STRINGS.editContextItem),
    }),
    [t],
  );

  return useMemo(
    () => ({
      open: (props: UseContextItemDialogOpenProps): void => {
        const dialogProps: DialogProps = {
          classes: 'ai-context-item-dialog',
          'data-id': 'AI Context Item Dialog',
          dialogContent: {
            renderContent: (dialogProps: DialogContentProps) => <AiContextItemDialog {...dialogProps} {...props} />,
          },
          dialogSize: DIALOG_SIZE_SM_MD,
          heading: props.contextItem ? labels.editContextItem : labels.createContextItem,
          icon: props.contextItem ? ICON_EDIT : ICON_ADD_CIRCLE,
          stateHandler: useDialogStore,
        };

        updateActiveDialog(dialogProps);
      },
    }),
    [labels, updateActiveDialog],
  );
};
